import buildQuery from "./buildQuery";

/**
 * Build valid url from current location
 *
 * @param {Array} additionalParams - additional parameters to join at the end after /
 * @param {Object} queryParams - query params, ex. ?page=1&perPage=3
 * @param {boolean} onlyOrigin - use only window location origin
 * @returns {string} valid url
 */
export default (
  additionalParams = [],
  queryParams = {},
  onlyOrigin = false
) => {
  let location = "";
  if (onlyOrigin) {
    location = window.location.origin.replace(/\/$/g, "");
  } else {
    location = window.location.href.replace(/\/$/g, "").replace(".html", "");
  }
  const pathname = `${
    additionalParams ? additionalParams.join("/") : ""
  }`.replace(/\/$/g, "");
  const query = buildQuery(queryParams);
  return `${location}/${pathname}${query}`.replace(/(?<!:)\/{2,}/g, "/");
};
